<template>
    <div class="content">
        <div class="notice-title">
            作品展示
        </div>
        <div class="btn">
            <div class="btn-item" :class="{ 'btn-active': num == 0 }" @click="tabClick(0)">
                <img src="@/assets/images/gz.png" alt="">
                <span>高职作品组</span>
            </div>
            <div class="btn-item" :class="{ 'btn-active': num == 1 }" @click="tabClick(1)">
                <img src="@/assets/images/zz.png" alt="">
                <span>中职作品组</span>
            </div>
        </div>
        <div class="list" v-if="list1.length>0">
            <div class="zp-slide" v-for="(item,index) in list1" :key="index" @click="previewDetail(item)" style="cursor:pointer">
                <div class="zpcover">
                    <img :src="getImg(item.name)" @error="handleError" class="zpimg" alt="">
                </div>
                <div class="zpconbox">
                    <p class="zptitle">{{ item.zpname }}</p>
                    <!-- <p class="zptext">专业名称：护理学</p> -->
                   <p class="zptext zptext-group"> <img src="@/assets/images/tjbh/z2.png" class="zpicons" alt />学校名称：{{item.realname}}</p>
                <p class="zptext zptext-group"> <img src="@/assets/images/tjbh/z1.png" class="zpicons" alt />作品负责人：{{item.principals}}</p>
                <p class="zptext zptext-group">
                  <img src="@/assets/images/tjbh/z3.png" class="zpicons" alt />
                  组别：<span>{{item.levelType=='1'?'中职组':item.levelType=='2'?'高职组':''}}</span>
                </p>

                </div>
            </div>
        </div>
        <div v-else>
             <img src="@/assets/images/bh/empty.png" class="emptyimg" alt />
        </div>
        <div class="page" v-if="total > 0">
            <a-pagination v-model="current" @change="onChange"  :page-size="12" :page-size-options="[10, 20, 30, 40]" :total="total" />
        </div>
        <div class="preview-pop-box" v-if="showPreviewPop">
            <div :class="fullscreen ? 'preview-box-fullscreen' : 'preview-box'">
                <preview
                    type="education"
                    routeName="alApply"
                    :video-only="true"
                    @goNewPage="goNewPage"
                    @closePreview="showPreviewPop = false"
                    :preViewData="preViewData"
                ></preview>
            </div>
        </div>
    </div>
</template>

<script>
import { getNoticeList,getAction} from "@/api/index";
import { baseURL } from "@/utils/request.js";
import Preview from "@/components/common/preview.vue";
export default {
    name: "workshow",
    components: { Preview },
    data() {
        return {
            current: 1,
            total: 0,
            list1: [],
            type: 1,
            num: 0,
            baseURL,
            emptyIMG:require('@/assets/images/empty.png'),
            preViewData: {},
            showPreviewPop: false,
            fullscreen: false
        };
    },
    created() {
        // this.type = this.$route.query.type;
       
    },
    mounted() {
         this.getlist(1);
    },
    methods: {
         // 组别名称(可按需改)
        getGroupName(index){
        const names = ['专业技能课程一组', '专业技能课程二组', '专业技能课程三组'];
        return names[index % names.length];
        },
        handleError(event){
            return event.target.src=this.emptyIMG;
        },
        getImg(img) {
            if (img) {
                return this.baseURL + img;
            } else {
                return '';
            }
        },
        tabClick(num) {
            this.current = 1
            this.num = num
            if(num=='0'){
                this.getlist(1);
            }else{
                this.getlist(0);
            }
            // this.getlist();
        },
        onChange(page, pageSize) {
            this.current = page;
            if(this.num=='0'){
                this.getlist(1);
            }else{
                this.getlist(0);
            }
            // this.getlist();
        },
        getTime(time) {
            if (time != '') {
                return time.substring(0, 10);
            } else {
                return '';
            }
        },
        getlist(num1) {
            let params = {
                pageNo: this.current,
                pageSize: 12,
            }
            getAction('/lx/lxApply/getScoredWorksPage?levelType='+(Number(num1)+1),params).then(res => {
                console.log(res);
                if (res.code == "200") {
                  this.list1=res.result.result.records;
                  this.total = res.result.result.total;
                }else{
                    this.$message.error(res.message);
                    this.list1=[];
                }
            });
        },
        previewDetail(item) {
            this.preViewData = item;
            this.showPreviewPop = true;
        },
        goNewPage(flag) {
            this.fullscreen = flag;
        },
    },
};
</script>

<style lang="scss" scoped>
.content {
    width: 1250px;
    margin: 0 auto;
}

.notice-title {
    font-size: 28px;
    font-weight: bold;
    // color: #9A0B00;
    color: #9A0B00;
    border-bottom: 1px solid #DE764D;
    // border-bottom: 1px solid #214cd9;
    padding-bottom: 12px;
}

.btn {
    margin-top: 26px;
    display: flex;

    .btn-item {
        width: 228px;
        height: 80px;
        border-style: solid;
        border-width: 1px;
        border-color: rgb(255, 255, 255);
        border-radius: 10px;
        background-color: #fff;
        box-shadow: 0px 0px 18px 0px rgba(12, 85, 198, 0.1);
        display: inline-block;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 24px;
        font-weight: bold;
        color: #9A0B00;
        margin-right: 22px;
        cursor: pointer;

        img {
            width: 54px;
            margin-right: 6px;
        }
    }

    .btn-item:hover,
    .btn-active {
        border-style: solid;
        border-width: 1px;
        border-color: rgb(255, 255, 255);
        border-radius: 10px;
        background-color: #9A0B00;
        box-shadow: 0px 0px 18px 0px rgba(12, 85, 198, 0.35);
        color: #ffffff;
    }
}
.emptyimg {
    margin: 100px auto 120px;
    display: block;
  }
.list {
    margin-top: 38px;
    // padding: 0 12px;
    // box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;

    .zp-slide {
        width: 298px;
        background-color: #ffffff;
        border: 1px solid #d4ecfe;
        border-radius: 5px;
        overflow: hidden;
        margin: 0 18px 18px 0;

        .zpcover {
            width: 100%;
            height: 180px;

            .zpimg {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }

        .zpconbox {
            padding: 12px 14px;

            .zptitle {
                font-size: 18px;
                color: #242424;
                font-weight: bold;
                line-height: 30px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                width: 100%;
                height: 30px;
                margin: 0px 0 6px;
            }

            .zptext {
                color: #4a4a4a;
                line-height: 22px;
                height: 22px;
                font-size: 13px;
                width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                margin: 0px;
                display: flex;
                align-items: center;
            }
            .zpicons {
                width: 16px;
                height: 16px;
                margin-right: 6px;
                object-fit: contain;
                flex-shrink: 0;
            }
        }
    }

    .zp-slide:nth-child(4n) {
        margin-right: 0;
    }
}

.page {
    width: 100%;
    text-align: center;
    margin: 30px 0 50px;
}
.preview-pop-box {
    width: 100vw;
    height: 100vh;
    position: fixed;
    z-index: 999;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
    .preview-box {
        margin: 50px auto;
        width: 1177px;
        height: 90%;
    }
    .preview-box-fullscreen {
        width: 100vw;
        height: 100vh;
    }
}
</style>